import { render, staticRenderFns } from "./SectionLocationList.vue?vue&type=template&id=6be477c8"
import script from "./SectionLocationList.vue?vue&type=script&lang=js"
export * from "./SectionLocationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports